import { useEffect, useRef, useState } from 'react';
import { useTooltipStore } from '@/ui/stores/tooltipStore';

export function MapTooltip() {
  const text = useTooltipStore((s) => s.text);
  const [pos, setPos] = useState({ x: 0, y: 0 });
  const posRef = useRef({ x: 0, y: 0 });

  useEffect(() => {
    const onMove = (e: MouseEvent) => {
      posRef.current = { x: e.clientX, y: e.clientY };
      setPos({ x: e.clientX, y: e.clientY });
    };
    document.addEventListener('mousemove', onMove);
    return () => document.removeEventListener('mousemove', onMove);
  }, []);

  if (!text) return null;

  return (
    <div
      style={{
        position: 'fixed',
        left: pos.x + 14,
        top: pos.y - 10,
        pointerEvents: 'none',
        zIndex: 9999,
        background: 'rgba(30,30,30,0.88)',
        color: '#fff',
        fontSize: '13px',
        fontFamily: 'sans-serif',
        padding: '4px 8px',
        borderRadius: '4px',
        whiteSpace: 'nowrap',
        boxShadow: '0 2px 6px rgba(0,0,0,0.5)',
      }}
    >
      {text}
    </div>
  );
}
